const API_URL = process.env.REACT_APP_API_URL || (window.location.origin + '/api');
const getHeaders = () => {
  const token = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
};
const handle = async (res) => {
  const data = await res.json();
  // El 403 de "activá el 2FA" NO es una sesión vencida: la sesión es válida, está
  // acotada a la activación. Deslogear ahí dejaría al usuario en un rulo de login.
  if ((res.status === 401 || res.status === 403)
      && data.code !== 'MFA_ENROLLMENT_REQUIRED'
      && data.error?.includes('Token')) {
    window.dispatchEvent(new CustomEvent('itil-session-expired'));
    throw new Error('Sesión expirada. Iniciá sesión nuevamente.');
  }
  if (!res.ok) throw new Error(data.error || 'Error desconocido');
  return data;
};
export const api = {
  login: (email, password) => fetch(`${API_URL}/auth/login`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password }) }).then(handle),
  me: () => fetch(`${API_URL}/auth/me`, { headers: getHeaders() }).then(handle),
  getAssets: (params = {}) => { const q = new URLSearchParams(params).toString(); return fetch(`${API_URL}/assets${q ? '?' + q : ''}`, { headers: getHeaders() }).then(handle); },
  getAsset: (id) => fetch(`${API_URL}/assets/${id}`, { headers: getHeaders() }).then(handle),
  getStats: () => fetch(`${API_URL}/assets/stats/summary`, { headers: getHeaders() }).then(handle),
  deleteAsset: (id) => fetch(`${API_URL}/assets/${id}`, { method: 'DELETE', headers: getHeaders() }).then(handle),
  getConfig: () => fetch(`${API_URL}/config`, { headers: getHeaders() }).then(handle),
  saveConfig: (key, value) => fetch(`${API_URL}/config`, { method: 'PUT', headers: getHeaders(), body: JSON.stringify({ key, value }) }).then(handle),
  getAdminInfo: () => fetch(`${API_URL}/config/admin-info`, { headers: getHeaders() }).then(handle),
};
